<template>
  <modal :heightOverride="300" ref="modal" closeButton hideActions>
    <div class="re-posting-modal">
      <div class="text-h4 font-weight-medium">
        Re-Forecast Target
      </div>
      <div class="mt-2">
        <target-details :target="currentTarget" />
      </div>
      <div class="mt-4 mb-1 red--text text--lighten-1">
        Select the start month to re-forecast the target
      </div>
      <v-row justify="center">
        <v-col sm="3">
          <v-select
            :items="options"
            item-text="name"
            item-value="value"
            label="Start Month"
            clearable
            dense
            outlined
            hide-details="true"
            @input="val => selectedDate = val"
          ></v-select>
        </v-col>
      </v-row>
      <div class="mt-7">
        <action-button
          :disabled="hasSelectedDate"
          color="secondary"
          @click.native="rePostTarget"
          label="Post Target"
          id="rePostBtn"
          ma-4
        >
        </action-button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal'
import TargetDetails from '@/appComponents/targets/components/TargetDetails'
import ActionButton from '@/components/common/actionButton'
import {REPOST_TARGET} from '@/appLogic/targets/currentTarget/store/actions'

export default {
  components: {
    Modal,
    TargetDetails,
    ActionButton,
  },
  data () {
    return {
      selectedDate: null
    }
  },
  computed: {
    showModal () {
      return this.$store.state.currentTarget.showRePostingModel
    },
    currentTarget () {
      return this.$store.state.currentTarget.currentTarget
    },
    hasSelectedDate () {
      return !this.selectedDate
    },
    dateRanges () {
      return this.$store.state.currentTarget.repostDates
    },
    options () {
      return this.dateRanges.map(el => {
        return {
          "name": el.name,
          "value": el.from
        }
      })
    }
  },
  methods: {
    open () {
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
    rePostTarget () {
      this.$store.dispatch(REPOST_TARGET, this.selectedDate)
      this.close()
    }
  },
  watch: {
    showModal () {
      if (this.showModal) {
        this.open()
      }
    }
  }
}
</script>

<style lang="scss">
.re-posting-modal {
  margin: 0 auto;
  text-align: center;

  &__selected-date {
    background-color: color(grays, light);
    border: 2px solid black;
    border-radius: 25px;
    width: 200px;
    margin: 0 auto;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// RePostingModal.vue?c6eff4d8